import React, { useCallback, useEffect, useState } from "react";
import { Badge, Input, Spinner, Table } from "reactstrap";
import { getUserGameHistory } from "../../../helpers/apis";

const GAME_OPTIONS = [
    { value: "", label: "All Games" },
    { value: "lt", label: "Lucky Target" },
    { value: "lt2", label: "Lucky Target 1" },
    { value: "lt3", label: "Lucky Target 2" },
    { value: "ro", label: "American Roulette" },
    { value: "so_web", label: "Sorat (Web)" },
    { value: "so_app", label: "Sorat (App)" }
];

const resultColor = { win: "success", lose: "danger", pending: "warning" };

const GameHistoryTab = ({ userId }) => {
    const [gameType, setGameType] = useState("");
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ history: [], summary: {}, pagination: {} });

    const load = useCallback(async () => {
        if (!userId) return;
        setLoading(true);
        try {
            const res = await getUserGameHistory(userId, { page, limit, ...(gameType ? { gameType } : {}) });
            if (res && res.status === 1 && res.data) setData(res.data);
        } finally {
            setLoading(false);
        }
    }, [userId, page, limit, gameType]);

    useEffect(() => { load(); }, [load]);

    const { history = [], summary = {}, pagination = {} } = data;
    const labelOf = (v) => GAME_OPTIONS.find(o => o.value === v)?.label || v;

    return (
        <div>
            <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
                <Input
                    type="select"
                    style={{ maxWidth: 220 }}
                    value={gameType}
                    onChange={(e) => { setGameType(e.target.value); setPage(1); }}
                >
                    {GAME_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </Input>
                {Object.entries(summary).map(([g, s]) => (
                    <small key={g} className="text-muted">
                        <b>{labelOf(g)}</b>: {s.count} bets, spent {s.spent}, won {s.won}
                    </small>
                ))}
            </div>

            {loading ? (
                <div className="text-center py-4"><Spinner color="primary" /></div>
            ) : history.length === 0 ? (
                <p className="text-center text-muted py-4">No game history found</p>
            ) : (
                <Table responsive hover className="align-middle mb-0">
                    <thead className="table-light">
                        <tr>
                            <th>Date & Time</th>
                            <th>Game</th>
                            <th>Ticket</th>
                            <th>Bet</th>
                            <th>Result</th>
                            <th>Reward</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map(row => (
                            <tr key={`${row.gameType}-${row.id}`}>
                                <td>{row.createdAt ? new Date(row.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) : "N/A"}</td>
                                <td>{labelOf(row.gameType)}</td>
                                <td>{row.ticketId || "-"}</td>
                                <td className="text-danger fw-semibold">-{row.amount}</td>
                                <td><Badge color={resultColor[row.result] || "secondary"}>{(row.result || "").toUpperCase()}</Badge></td>
                                <td className="text-success fw-semibold">{row.reward || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

            {pagination.totalPages > 1 && (
                <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                    <button className="btn btn-light btn-sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</button>
                    <small>{page} / {pagination.totalPages}</small>
                    <button className="btn btn-light btn-sm" disabled={page >= pagination.totalPages} onClick={() => setPage(p => p + 1)}>Next</button>
                </div>
            )}
        </div>
    );
};

export default GameHistoryTab;
